import React from "react";

import classes from "./CustomDropDown.module.css";

const CustomDropDown = (props) => {
    return (
        <div className={classes.CustomDropDown} onClick={() => {
            props.setshowDrop(false);
            props.setHeaderVal(null);
        }}>
            {props.children}
        </div>
    )
};

export default CustomDropDown;